import React from 'react';
import styled from '@emotion/styled';
import propTypes, { defaultProps } from './propTypes';
import {
  CardTextContainer,
  CardDate,
  FullWidthImageContainer,
  CardContainer,
  CardOverline,
  CardBodyText,
} from '../Card';
import Labels from '../Card/Labels';
import Headline4 from '../Typography/Heading/Headline4';
import breakpoints from '../Theme/breakpoints';

const FlexWideCard = styled.div`
display: flex;
flex-direction: column;

@media (min-width: ${breakpoints.sm}px) {
  flex-direction: row;
}
`;

const FlexWideCardItemImage = styled.div`
order: 1;

@media (min-width: ${breakpoints.sm}px) {
  order: 2;
  flex-basis: calc(50%);
}
`;

const FlexWideCardItemText = styled.div`
  order: 2;

@media (min-width: ${breakpoints.sm}px) {
  order: 1;
  flex-basis: calc(50%);
}
`;

const MiddleHeading = styled(Headline4)`
  && {
    margin: 0 0 16px;
  }
`;

const StyledCardTextContainer = styled(CardTextContainer)`

  @media (min-width: ${breakpoints.sm}px) {
    padding: 0 16px 0 0;
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding: 0 24px 0 0;
  }
`;

const WideCard = ({
  title,
  description,
  category,
  createdAt,
  image,
  labels,
  withPageMargins,
}) => (
  <FlexWideCard>
    <FlexWideCardItemImage>
      <FullWidthImageContainer withPageMargins={withPageMargins}>
        {image}
      </FullWidthImageContainer>
    </FlexWideCardItemImage>
    <FlexWideCardItemText>
      <CardContainer className="card-container">
        <StyledCardTextContainer>
          <CardOverline
            className="highlight-color"
          >
            {category}
            <Labels labels={labels} />
          </CardOverline>
          <MiddleHeading tag="h2">
            {title}
          </MiddleHeading>
          <CardBodyText>
            {description}
          </CardBodyText>
          {createdAt && (
            <CardDate>
              {createdAt}
            </CardDate>
          )}
        </StyledCardTextContainer>
      </CardContainer>
    </FlexWideCardItemText>
  </FlexWideCard>
);

WideCard.defaultProps = defaultProps;

WideCard.propTypes = propTypes;

export default WideCard;
